function toggleCalendarFilters(event) {
    event.preventDefault();

    var toggle = event.target.closest('.js-calendar-filters-toggle');
    if (!toggle) return;

    var wrapper = toggle.closest('.js-calendar-filters');
    if (!wrapper) return;

    var isOpen = wrapper.classList.contains('is-open');

    if (isOpen) {
        wrapper.classList.remove('is-open');
        wrapper.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-expanded', 'false');
    } else {
        wrapper.classList.add('is-open');
        wrapper.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-expanded', 'true');
    }
}

function applyCalendarFilterClicks() {
    document.querySelectorAll('.js-calendar-filters-toggle').forEach(function (t) {
        t.addEventListener('click', function (event) {
            toggleCalendarFilters(event);
        }, false);
    });
}

applyCalendarFilterClicks();
